import React from 'react';
import ReactDOM from 'react-dom/client';
import Clarity from '@microsoft/clarity';
import './index.css';
import App from './App';

if (
  process.env.NODE_ENV === 'production' &&
  process.env.REACT_APP_CLARITY_PROJECT_ID
) {
  Clarity.init(process.env.REACT_APP_CLARITY_PROJECT_ID);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
